import { Alert, Button, Divider, Form, Input, Space, Typography } from 'antd'
import { useEffect, useState } from 'react'
import i18n from '../../i18n/setupLocalization'
import { useAuth } from '../../contexts/Auth'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { Link } from 'react-router-dom'
import {
  capsRule,
  containsNumberRule,
  containsSymbolRule,
  emailRule,
  lowercaseRule,
  minLengthRule,
  requiredRule,
} from '../../helpers/rules'

const { Title } = Typography

export function ResetPassword() {
  const { resetPassword } = useAuth()
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [result, setResult] = useState<string | undefined>(undefined)

  const onFinish = async (values: {
    email: string
    token: string
    password: string
  }) => {
    setIsLoading(true)
    setResult(undefined)
    resetPassword(values.email, values.token, values.password)
      .then(() => {
        setResult(i18n.t(LocalizationKeys.Page.ResetPassord.Success))
      })
      .catch(() => {
        setResult(i18n.t(LocalizationKeys.Page.ResetPassord.Failure))
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search)
    const email = queryParameters.get('email')
    const token = queryParameters.get('token')
    if (!email || !token) {
      setResult(i18n.t(LocalizationKeys.Page.ResetPassord.WrongUrlParameters))
      return
    }

    form.setFieldsValue({ email: email!, token: token! })
  }, [])

  return (
    <Space
      direction="vertical"
      style={{ padding: 20, textAlign: 'center' }}
      size={20}
    >
      {result && (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Alert style={{ marginBottom: 25 }} message={result} type="success" />
        </div>
      )}
      <Title level={3}>
        {i18n.t(LocalizationKeys.Page.ResetPassord.Title)}
      </Title>
      <Form form={form} onFinish={onFinish}>
        <Form.Item name="token" hidden rules={[requiredRule()]}>
          <Input type="hide" />
        </Form.Item>
        <Form.Item name="email" rules={[requiredRule(), emailRule()]}>
          <Input
            size="large"
            disabled
            className="authField"
            placeholder={i18n.t(LocalizationKeys.Misc.Form.Email)}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            requiredRule(),
            minLengthRule(12),
            lowercaseRule(),
            capsRule(),
            containsNumberRule(),
            containsSymbolRule(),
          ]}
        >
          <Input.Password
            size="large"
            className="authField"
            placeholder={i18n.t(LocalizationKeys.Misc.Form.Password)}
            autoComplete="current-password"
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 15 }}>
          <Button
            size="large"
            className="w-full"
            type="primary"
            htmlType="submit"
            loading={isLoading}
          >
            {i18n.t(LocalizationKeys.Page.ForgotPassword.Submit)}
          </Button>
        </Form.Item>
      </Form>
      <Divider />
      <Space
        style={{ justifyContent: 'center', width: '100%' }}
        direction="vertical"
      >
        <Link to={'/auth/login'}>
          {i18n.t(LocalizationKeys.Page.ForgotPassword.AlreadyHaveAccount)}
        </Link>
        <Link to={'/auth/register'}>
          {i18n.t(LocalizationKeys.Page.Register.Title)}
        </Link>
      </Space>
    </Space>
  )
}
